import { useState, useEffect } from 'react';
export const useDisabledWidget = function (widgetConfig) {
  if (widgetConfig === void 0) {
    widgetConfig = {
      messageIndex: 0,
      messagesCount: 1,
      onEnable: () => {}
    };
  }
  const {
    messageIndex = 0,
    messagesCount = 1,
    onEnable = () => {}
  } = widgetConfig;
  const [areControlsDisabled, setAreControlsDisabled] = useState(false);
  useEffect(() => {
    const shouldDisable = messageIndex !== messagesCount - 1;
    setAreControlsDisabled(shouldDisable);
  }, [messageIndex, messagesCount]);
  const enableControls = () => {
    setAreControlsDisabled(false);
    onEnable();
  };
  return {
    areControlsDisabled,
    enableControls
  };
};
//# sourceMappingURL=useDisabledWidget.js.map